var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('input',{attrs:{"id":"filepicker","type":"file","accept":"image/*"},on:{"change":_vm.handleFileSelect}}),_c('label',{staticClass:"button",attrs:{"for":"filepicker"}},[_vm._v("Choose an image")])])}
var staticRenderFns = []

export { render, staticRenderFns }